class LeaderListController {
    constructor($http, $window, $element, $timeout) {
        'ngInject';
        this.$http = $http;
        this.$window = $window;
        this.$element = $element;
        this.$timeout = $timeout;

        this.data = [];
        this.dataOverflow = [];
        this.isOverflow = false;

        this.collapsed = true;
        this.collapsing = false;

        this.spinner = true;

        this.httpError = false;
    }

    $onInit() {
        this.$timeout(() => {
            this.$http({
                url: '/api/chapterleader/getchapterleaders',
                method: 'GET'
            }).then((response) => {
                if(response.data.length > 8) {
                    this.data = response.data.splice(0, 8);
                    this.dataOverflow = response.data;
                    this.isOverflow = true;
                } else {
                    this.data = response.data;
                }
                this.spinner = false;
            }, (response) => {
                this.spinner = false;
                this.httpError = true;
            });
        }, 1000);
    }

    toggleOverflow() {
        if(this.collapsed) {
            this.collapsing = true;
            this.$timeout(() => {
                this.collapsing = !this.collapsing;
                this.collapsed = !this.collapsed;
            });
            $('.c-leader-list .js-focus').focus();
        } else {
            this.collapsed = !this.collapsed;
        }
    }

    focusTrap() {
        if(!this.collapsed) {
            $('.js-focus').focus();
        }
    }
}

export default LeaderListController;



// WEBPACK FOOTER //
// ./src/app/angular/leader-list/leader-list.controller.js